import { render, staticRenderFns } from "./activityRedirect.vue?vue&type=template&id=13937ada&scoped=true"
import script from "./activityRedirect.vue?vue&type=script&lang=js"
export * from "./activityRedirect.vue?vue&type=script&lang=js"
import style0 from "./activityRedirect.vue?vue&type=style&index=0&id=13937ada&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13937ada",
  null
  
)

export default component.exports